import { useRouter } from 'next/router';

export const useLmsDestinationsFromQuery = (): string[] => {
    const router = useRouter();

    const param: string | string[] | undefined = router.query.til;
    const raw: string[] = param ? (Array.isArray(param) ? param : [param]) : [];

    return raw.flatMap((value) => value.split(',')).filter(Boolean);
};
